// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles-module__modal___3t_Rp"};